import { xovisGetRequest } from '../../../../../api/xovis/xovis.api';

/**
 * Получение информации о мультисенсоре
 * @param {object} sensor объект сенсора
 * @param {number} timeout timeout
 * @returns объект с ошибкой или информацию о мультисенсоре
 */
const getXovisMultisensorInfoV5 = async (args) => {
    const { sensor, timeout } = args;

    const multisensorInfo = await xovisGetRequest({
        url: `http://${sensor.ip}:${sensor.port}/api/v5/multisensor`,
        username: sensor.username,
        password: sensor.password,
        timeout,
    });

    if (!multisensorInfo.error) {
        return {
            isMultiSensor: multisensorInfo.enabled || false,
        };
    }

    return { error: 'Ann error accrued while getting multisensor info' };
};

export default getXovisMultisensorInfoV5;
